const FORM_GENERATOR = {
  WORKING_HOURS: 'Working Hours',
  NON_WORKING_HOURS: 'Non-Working Hours',
  FORM_GENERATOR_BTN_RELEASE: 'Publish',
  FORM_GENERATOR_TITLE_PAGE: 'Working and non-working hours form creation page',
  FORM_GENERATOR_NECESSARY_INFO: 'It is necessary to receive information',
  FORM_GENERATOR_FIRST_MSG: 'Submit the form before sending the message',
  FORM_GENERATOR_TITLE_INPUT: 'Form Title',
  FORM_GENERATOR_USER_MANUAL:
    'To apply changes, press the publish button at the bottom of the page.',
  FORM_GENERATOR_ACTIVE_FORM: 'Active',
  FORM_GENERATOR_INACTIVE_FORM: 'Inactive',
  ERROR_MESSAGE: 'Filling in the added form is essential!',
  TITLE_ERROR_MESSAGE: 'Writing form title is essential!',
  FORM_NECESSARY: 'Adding form is required!',
};

export default FORM_GENERATOR;
